const mutations = {
  mutationInvoice(state, payload) {
    state.invoice = payload;
  },

  mutationInvoiceList(state, payload) {
    if (payload && (payload.tab || payload.tab === 0)) {
      state.invoiceList[payload.tab] = payload.responseData;
    } else {
      state.invoiceList = payload;
    }
  },

  mutationInvoiceListMeta(state, payload) {
    state.invoiceListMeta = payload;
  },
  mutationSelectedInsurer(state, payload) {
    state.selectedInsurer = payload;
  },
};

export default mutations;
